module.exports = __webpack_public_path__ + "img/dynamic-banner.c7aea99a.png";